import React from "react";
import PropTypes from "prop-types";
import { StaticImage } from "gatsby-plugin-image";
import { useInView } from "react-intersection-observer";

// components
import Button from "../../Button/Button";

// styles
import * as styles from "./BuildCareer.module.css";

const propTypes = {
  title: PropTypes.string,
  description1: PropTypes.string,
  description2: PropTypes.string,
  description3: PropTypes.string,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
  onCtaClick: PropTypes.func,
};

const defaultProps = {
  title: "Why Build Your Career at Twin Health?",
  description1:
    "At Twin Health, we're on a mission to transform lives by addressing the root causes of chronic metabolic diseases through cutting-edge AI/ML-driven technology and compassionate care. We empower individuals to achieve better health, greater happiness, and freedom from chronic conditions.",
  description2:
    "When you join Twin Health, you become part of a team dedicated to innovation, collaboration, and impact. Together, we're not just building solutions; we're changing the future of healthcare and improving millions of lives across India and beyond.",
  description3:
    "Take the next step in your career, and be a part of something that truly makes a difference.",
  ctaText: "View Open Roles",
  ctaLink: "",
  onCtaClick: () => {},
};

const BuildCareer = ({
  title,
  description1,
  description2,
  description3,
  ctaText,
  ctaLink,
  onCtaClick,
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const handleCtaClick = e => {
    if (onCtaClick) {
      onCtaClick(e);
    }
  };

  return (
    <section className={styles.buildCareerWrapper}>
      <div
        className={`container scroll_animate ${inView && "inview"}`}
        ref={ref}
      >
        <div className="row align-items-center">
          {/* Image Column */}
          <div className="col-lg-6 col-12 order-1">
            <div className={styles.imageContainer}>
              <StaticImage
                src="../../../images/career/career-img.png"
                alt="Career at Twin Health"
                placeholder="blurred"
                className={styles.careerImage}
                loading="lazy"
              />
            </div>
          </div>

          {/* Content Column */}
          <div className="col-lg-6 col-12 order-2">
            <div className={styles.contentContainer}>
              <h2 className={styles.title}>{title}</h2>
              <p className={styles.description}>{description1}</p>
              <p className={styles.description}>{description2}</p>
              <p className={styles.description}>{description3}</p>
              <div className={styles.ctaContainer}>
                <Button
                  text={ctaText}
                  href={ctaLink}
                  variant="primary"
                  onClick={handleCtaClick}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

BuildCareer.propTypes = propTypes;
BuildCareer.defaultProps = defaultProps;

export default BuildCareer;
